import { yup } from '@framework/validation';

export enum PdfVisibilityDirectiveKind {
  /**
   * Mostra il campo solo nel PDF
   */
  PDF = 'pdf',

  /**
   * Mostra il campo solo in compilazione
   */
  COMPILATION = 'compilation',

  /**
   * Mostra il campo sia in compilazione che nel PDF
   */
  ALL = 'all',
}

export interface IPdfVisibilityDirective {
  visibility: PdfVisibilityDirectiveKind;
}

export const PdfVisibilityDirectiveSchema: yup.ObjectSchema<IPdfVisibilityDirective> =
  yup
    .object({
      visibility: yup
        .string()
        .oneOfEnum(PdfVisibilityDirectiveKind)
        .default(PdfVisibilityDirectiveKind.ALL)
        .optional()
        .label('Visibilità PDF'),
    })
    .noUnknown();
